import React, { Component } from 'react'
import { injectScript, removeScript } from 'srcReact/helpers/utils'

class GoogleMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      timeoutId: null,
      language: props.language || 'en' // Simplified language assignment
    }
    this.scriptId = 'google-map-script' // Moved scriptId inside the constructor
    this.scriptUrl = `https://maps.googleapis.com/maps/api/js?libraries=places`
  }

  componentDidMount() {
    const { apiKey } = this.props
    const { language } = this.state
    if (apiKey && !window.google) {
      // Check if window.google is not available
      injectScript(this.scriptId, `${this.scriptUrl}&language=${language}&key=${apiKey}`)
    }
    this.initializeService()
  }

  componentWillUnmount() {
    removeScript(this.scriptId)
    if (this.state.timeoutId) {
      clearTimeout(this.state.timeoutId) // Clear timeout to prevent memory leak
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lat !== this.props.lat || prevProps.lng !== this.props.lng) {
      this.process()
    }
  }

  process() {
    if (!window.google || !window.google.maps) return // Check if google maps is available
    const latlng = new window.google.maps.LatLng(this.props.lat, this.props.lng)
    const options = {
      zoom: this.props.zoom || 8, // Simplified zoom assignment
      center: latlng
    }
    const map = new window.google.maps.Map(document.getElementById('googleMap'), options)
    new window.google.maps.Marker({
      position: latlng,
      map: map,
      title: this.props.title || '' // Simplified title assignment
    })
  }

  initializeService = () => {
    if (!window.google || !window.google.maps) {
      const timeoutId = setTimeout(this.initializeService, 500)
      this.setState({ timeoutId })
    } else {
      this.process()
      this.setState({ timeoutId: null })
    }
  }

  render() {
    return <div id='googleMap' className={this.props.className}></div>
  }
}

export { GoogleMap }
